// extracted by mini-css-extract-plugin
module.exports = {"blogContent":"NewestItem_blogContent__YcpFP","blogTitle":"NewestItem_blogTitle__2GiMg","linkBtn":"NewestItem_linkBtn__2IEok","image":"NewestItem_image__qSrsf"};